import { PaymentStates, PaymentTypes } from '@cashier/cashier-model';

export const PaymentStateChecker = {
  isSuccess: (type: PaymentTypes | null, state: string): boolean => {
    if (PaymentTypes.Deposit === type) {
      return (
        PaymentStates.SUCCESSFUL === state ||
        PaymentStates.FORCE_SUCCESSFUL === state
      );
    }

    if (PaymentTypes.Withdrawal === type) {
      return (
        PaymentStates.PROCESSING === state ||
        PaymentStates.SUCCESSFUL === state ||
        PaymentStates.FORCE_SUCCESSFUL === state
      );
    }

    return false;
  },
  isFailed: (_: PaymentTypes | null, state: string): boolean => {
    return (
      PaymentStates.FAILED === state ||
      PaymentStates.CANCELLED === state ||
      PaymentStates.FORCE_FAILED === state
    );
  },
  isPending: (type: PaymentTypes, state: string): boolean => {
    if (PaymentTypes.Deposit === type) {
      return PaymentStates.PROCESSING === state;
    }

    return false;
  },
  isFinalized: (_: PaymentTypes, state: string): boolean => {
    return (
      PaymentStates.SUCCESSFUL === state ||
      PaymentStates.FAILED === state ||
      PaymentStates.CANCELLED === state ||
      PaymentStates.FORCE_SUCCESSFUL === state ||
      PaymentStates.FORCE_FAILED === state
    );
  },
  hasResult: (type: PaymentTypes | null, state: string): boolean => {
    return (
      PaymentStateChecker.isSuccess(type, state) ||
      PaymentStateChecker.isFailed(type, state)
    );
  },
};
